function waitForGoogle() {
    return new Promise((resolve, reject) => {
        let tries = 0;
        function check() {
            if (window.google && window.google.accounts && window.google.accounts.id) {
                resolve();
            } else if (tries++ < 50) {
                setTimeout(check, 100);
            } else {
                reject(new Error("Google Identity script not loaded"));
            }
        }
        check();
    });
}

const oauthService = {
    async init(onTokenReady) {
        await waitForGoogle();
        window.google.accounts.id.initialize({
            client_id: import.meta.env.VITE_OAUTH_GOOGLE_CLIENT_ID,
            callback: (response) => {
                const idToken = response.credential;
                onTokenReady(idToken);
            },
        });
    },

    async renderButton(container) {
        await waitForGoogle();
        if (container) {
            window.google.accounts.id.renderButton(container, {
                theme: "filled_blue",
                size: "large",
                text: "continue_with",
            });
        }
    },

    async promptOneTap() {
        await waitForGoogle();
        window.google.accounts.id.prompt();
    },

    async exchangeIdToken(idToken) {
        const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/google`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ idToken, rememberMe: true }),
        });
        if (!res.ok) throw new Error("Google login failed");
        return res.json();
    },
};

export default oauthService;
